import moment from "moment";
import * as React from "react";

import config from "../config/config";

import useOverviewData from "../hooks/useOverviewData";
import Overview from "../components/Overview";
import DriverForm from "../components/DriverForm";

import './DriverDetail.css';
import t from "../hooks/useTranslation";
import UserForm from "../components/UserForm";

const INITIAL_BRICKS_DATA = [
    {
        label: t('name'),
        isLoading: true,
        dataKey: 'name'
    },
    {
        label: t('workingTime'),
        isLoading: true,
        dataKey: 'workingTime',
        valueRenderer: ({workingTime}) => t(workingTime)
    },
    {
        label: t('ridesCount'),
        isLoading: true,
        dataKey: 'routeCount'
    },
    {
        label: t('hiredDate'),
        isLoading: true,
        valueRenderer: ({hiredDate}) => hiredDate ? moment(hiredDate).format('DD.MM.YYYY') : ''
    }
];

function UserDetail(props) {
    const {
        isLoading,
        error,
        response,
        bricksData,
    } = useOverviewData(config.apiRouteMap.getUser(props.match.params.id), INITIAL_BRICKS_DATA);

    return (
        <div className="UserDetail">
            <Overview
                isLoading={isLoading}
                introduction={t('introductionText')}
                title={t('userDetail')}
                bricks={bricksData}
                error={error}
            >
                <UserForm
                    history={props.history}
                    data={response}
                    isLoading={isLoading}
                    error={error}
                />
            </Overview>
        </div>
    );
}

export default UserDetail;
